export default {
  COMMON: {
    REJECT: 'Rechazar',
    CONTINUE: 'Continuar',
    SIGN: 'Firmar',
    LOADING: 'Cargando...',
    VERIFY: 'Verificar',
    CANCEL: 'Cancelar',
    VIEW: 'Ver',
    DOWNLOAD: 'Descargar',
    ATTACHMENTS: 'Archivos adjuntos',
    DOCUMENTS: 'Documentos',
    READ: 'Leído',
    CHECKED: 'Revisado',
  },

  APPROVER_INBOX: {
    TITLE: 'Bandeja de órdenes',
    SUBTITLE: 'Seleccione las órdenes que desea firmar.',
    SELECT_ALL: 'Seleccionar todas las órdenes',
    SELECT_ALL_ORDERS: 'Seleccionar todas las órdenes',
    LOADING: 'Cargando bandeja de entrada...',
    EMPTY: 'No se encontraron órdenes.',
    EMPTY_TITLE: 'No hay órdenes de firma pendientes de aprobación',
    EMPTY_SUBTITLE: 'Actualmente no hay órdenes de firma pendientes de su aprobación.',
    ERROR_LOAD: 'No se pudo cargar la bandeja de entrada.',
    UNKNOWN_SENDER: 'Remitente desconocido',
    SENT_YOU_FILES: 'le ha enviado documentos para firmar',
    VIEW_FILE: 'Ver archivo',
    REJECT_ORDER: 'Rechazar orden',
    REVIEW_SELECTED: 'Revisar seleccionadas ({{count}})',
    EXPAND: 'Expandir',
    COLLAPSE: 'Contraer',
    CREATED: 'Creada',
    ONE_FILE: '1 archivo',
    MANY_FILES: 'documentos',
    MORE: 'Más',
    COPY_HASHSUM: 'Copiar hash',
  },
  APPROVER_SIGN: {
    TITLE: 'Documentos del acuerdo para firma',
    INSTRUCTION: 'He leído y acepto el contenido de los siguientes documentos del acuerdo. Una vez que haya firmado los acuerdos, quedaré vinculado por ellos.',
  },
  TAB_DETECTION: {
    TITLE: 'Este enlace ya está en uso en otra pestaña.',
    SUBTITLE: 'Cierre la otra pestaña y vuelva a cargar esta página.',
  },

  FORMS: {
    NO_COUNTRIES_FOUND: 'No se encontraron países',
    NO_RESULTS_FOUND: 'No se encontraron resultados',
    CHOOSE_FILES: 'Elegir archivos',
    NO_FILE_CHOSEN: 'Ningún archivo seleccionado',
    SELECT_AN_OPTION: 'Seleccione una opción',
    SEARCH: 'Buscar...',
    ERRORS: {
      REQUIRED: 'Este campo es obligatorio',
      EMAIL: 'Introduzca una dirección de correo electrónico válida',
      MIN_LENGTH: 'La longitud mínima es de {{requiredLength}} caracteres',
      MAX_LENGTH: 'La longitud máxima es de {{requiredLength}} caracteres',
      INVALID: 'Valor no válido',
      ONLY_NUMBERS: 'Solo se permiten números',
      FILE_TYPE: 'El archivo debe ser jpeg, jpg, bmp, gif o pdf',
      CPR_ONLY_DIGITS: 'El CPR debe contener solo dígitos',
      CPR_LENGTH: 'El CPR debe tener exactamente 10 dígitos',
      CPR_INVALID: 'El número CPR no es válido',
      BANK_ACCOUNT_REG_ONLY_NUMERIC: 'Solo se permiten números',
      BANK_ACCOUNT_REG_FOUR_DIGITS: 'El número de registro bancario debe tener exactamente 4 dígitos',
      CVR_ONLY_NUMERIC: 'Solo se permiten números',
      CVR_EIGHT_DIGITS: 'El CVR debe tener exactamente 8 dígitos',
    },
  },

  CALENDAR: {
    DAYS: {
      SUN: 'Dom',
      MON: 'Lun',
      TUE: 'Mar',
      WED: 'Mié',
      THU: 'Jue',
      FRI: 'Vie',
      SAT: 'Sáb',
    },
    MONTHS: {
      JANUARY: 'Enero',
      FEBRUARY: 'Febrero',
      MARCH: 'Marzo',
      APRIL: 'Abril',
      MAY: 'Mayo',
      JUNE: 'Junio',
      JULY: 'Julio',
      AUGUST: 'Agosto',
      SEPTEMBER: 'Septiembre',
      OCTOBER: 'Octubre',
      NOVEMBER: 'Noviembre',
      DECEMBER: 'Diciembre',
    },
  },

  SIGNATURE: {
    CLEAR_SIGNATURE: 'Borrar firma',
    YOUR_SIGNATURE: 'Su firma',
    AGREEMENT_DOCUMENT_TITLE: 'Documento del acuerdo para firma',
    AGREEMENT_DOCUMENT_DESCRIPTION: 'Al firmar el acuerdo, indico que he leído y acepto el contenido del siguiente documento del acuerdo. Mi firma es vinculante.',
    FORM_DESCRIPTION: 'Al firmar el formulario, indico que he leído y acepto el contenido del siguiente formulario. Mi firma es vinculante.',
    SIGN_HERE: 'Firme aquí',
  },

  STEPS: {
    LOGIN_SHARED_SECRET: 'Inicio de sesión con código acordado',
    LOGIN_OTP: 'Inicio de sesión con OTP',
    LOGIN_EID: 'Inicio de sesión con eID',
    LOGIN_MITID: 'Inicio de sesión con MitID',
    REVIEW_FILES: 'Revisar archivos',
    REVIEW_DOCUMENTS: 'Leer documentos',
    REVIEW_FORMS: 'Leer formularios',
    ORDER_QUESTIONS: 'Preguntas de la orden',
    SIGN: 'Firmar documento',
    SIGN_FORM: 'Formulario para firma',
    RECEIPT: 'Recibo',
    DOWNLOAD: 'Descarga',
    CPR: 'Verificación CPR',
    FILE: 'Carga de archivos',
    FILES: 'Entrega segura',
    APPROVER_REVIEW_FILES: 'Bandeja de órdenes',
    APPROVER_SIGN: 'Documentos del acuerdo para firma',
  },
  LOGIN_OTP: {
    INSTRUCTION: 'Introduzca el código SMS que recibió en su teléfono. El código se ha enviado al número {{ phoneNumber }}.',
    OTP_CODE: 'Código OTP',
    OTP_EXPIRED: 'El código OTP ha caducado. Solicite uno nuevo.',
    RESEND_OTP: 'Reenviar OTP',
    RESEND_OTP_IN: 'Reenviar OTP en',
    OTP_PHONE_INSTRUCTION: 'Introduzca el código de 6 dígitos enviado a su teléfono.',
  },
  LOGIN_SHARED_SECRET: {
    INSTRUCTION: 'Para verificar su identidad y acceder a sus documentos, introduzca el código acordado que recibió de {{ senderName }}.',
    SHARED_SECRET: 'Código acordado',
    SHARED_SECRET_ERROR: 'El código acordado no coincide',
    SHARED_SECRET_REQRUIRED: 'El código acordado es obligatorio',
  },

  LOGIN_EID: {
    POPUP_ALERT: 'Desactive el bloqueador de ventanas emergentes e inténtelo de nuevo.',
    ORIGIN_MISMATCH: 'Advertencia de seguridad: el origen del proveedor de identidad no coincide. Inténtelo de nuevo.',
    SUCCESS: 'Ha iniciado sesión correctamente.',
    AUTHENTICATED: 'Autenticación correcta.',
    ERROR: 'Error al iniciar sesión. Inténtelo de nuevo.',
    INSTRUCTION: 'Para acceder y firmar sus documentos de forma segura, inicie sesión con su eID. Elija a continuación un método de inicio de sesión para continuar.',
    SINGLE_PROVIDER_INSTRUCTION: 'Para acceder y firmar sus documentos de forma segura, debe iniciar sesión para continuar.',
    FORM_INSTRUCTION: 'Para acceder y firmar su formulario de forma segura, inicie sesión con su eID. Elija a continuación un método de inicio de sesión para continuar.',
    FORM_SINGLE_PROVIDER_INSTRUCTION: 'Para acceder y firmar su formulario de forma segura, debe iniciar sesión para continuar.',
    CPR_INSTRUCTION: 'Inicie sesión con su MitID/eID para verificar su identidad. Elija a continuación un método de inicio de sesión para continuar.',
    CPR_SINGLE_PROVIDER_INSTRUCTION: 'Inicie sesión con su MitID/eID para verificar su identidad.',
    PROVIDERS: {
      mitid: 'Iniciar sesión con MitID',
      'mitid-business': 'Iniciar sesión con MitID Business',
      bankid_no: 'Iniciar sesión con BankID noruego',
      swedish_bank_id: 'Iniciar sesión con BankID sueco',
      default: 'Iniciar sesión con {{name}}',
    },
    MITID_BUSINESS_SUBTITLE: 'Se puede utilizar si su empresa o asociación se ha adherido a MitID Business',
  },

  REVIEW_FILES: {
    INSTRUCTION: 'Descargue o abra todos los archivos adjuntos.\nUna vez que todo se haya descargado o abierto, el remitente recibirá una notificación\nUna vez que todos los archivos adjuntos se hayan descargado o abierto, podrá continuar al recibo',
    SHOW_ALL_SIGNERS: 'Estado de los firmantes',
    ATTACHMENTS: 'Archivos adjuntos',
    DESCRIPTION: 'Vea quién ha firmado y quién falta por firmar.',
    NO_SIGNERS_FOUND: 'No se encontraron firmantes',
    FILES_LEFT: 'Debe leer los {{count}} documento(s) restantes.',
    FILES_READ_ALL: 'Ha leído todos los documentos. Ya puede continuar con la firma.',
    FORM_FILES_LEFT: 'Debe leer los {{count}} formulario(s) restantes.',
    FORM_FILES_READ_ALL: 'Ha leído todos los formularios. Ya puede continuar con la firma.',
    GO_TO_RECEIPT: 'Ir al recibo',
    CONTINUE: 'Continuar',
    FILES: 'Documentos',
  },

  REVIEW_DOCUMENTS: {
    INSTRUCTION: 'Abra y lea todos los documentos y los archivos adjuntos que aparecen a continuación.',
    FORM_INSTRUCTION: 'Abra y lea todos los formularios y los archivos adjuntos que aparecen a continuación.',
    FILES: 'Documentos',
    FORM_FILES_ONE: 'Formulario',
    FORM_FILES_MANY: 'Formularios',
    SHOW_ALL_SIGNERS: 'Estado de los firmantes',
    ATTACHMENTS: 'Archivos adjuntos',
    DESCRIPTION: 'Vea quién ha firmado y quién falta por firmar.',
    NO_SIGNERS_FOUND: 'No se encontraron firmantes',
  },

  SIGN_DOCUMENT: {
    INSTRUCTION: 'Abra y lea todos los documentos y los archivos adjuntos que aparecen a continuación.',
  },

  ORDER_QUESTIONS: {
    INSTRUCTION: 'Rellene los campos siguientes.',
    LOADING: 'Cargando preguntas...',
    SAVING: 'Guardando...',
    REQUIRED_FIELDS_WARNING: 'preguntas obligatorias sin responder',
    GOTO_FIRST_UNANSWERED: 'Ir a la primera',
    INPUTS_NOT_EQUAL: 'Los valores introducidos no coinciden',
    ENTER_FIELD_PLACEHOLDER: 'Introduzca {{field}}',
    ENTER_ZIP_CODE_PLACEHOLDER: 'Introduzca el código postal',
    ENTER_EMAIL_PLACEHOLDER: 'Introduzca la dirección de correo electrónico',
    ENTER_VALUE_PLACEHOLDER: 'Introduzca un valor',
    YES: 'Sí',
    NO: 'No',
    ERRORS: {
      REQUIRED: 'Este campo es obligatorio.',
      EMAIL: 'Introduzca una dirección de correo electrónico válida.',
      CPR: 'Introduzca un número CPR válido.',
      CVR_ONLY_NUMERIC: 'Solo se permiten números.',
      CVR_EIGHT_DIGITS: 'El CVR debe tener exactamente 8 dígitos.',
      BANK_REGISTRATION_NUMBER_ONLY_NUMERIC: 'Solo se permiten números.',
      BANK_REGISTRATION_NUMBER_FOUR_DIGITS: 'El número de registro bancario debe tener exactamente 4 dígitos.',
      PATTERN: 'Formato no válido.',
      VALUE_NOT_ALLOWED: 'Este valor no se puede utilizar. Introduzca otro distinto.',
      BACKEND_INVALID: 'No se pudo guardar este valor. Inténtelo de nuevo.',
      FILE_TYPE: 'Este tipo de archivo no está permitido.',
      INVALID: 'Valor no válido.',
    },
  },

  RECEIPT: {
    SUCCESS_HEADING: 'Su firma se ha completado correctamente',
    FILES_ORDER_SUCCESS_HEADING: 'Sus archivos han sido recuperados',
    FILES_ORDER_SUCCESS_MESSAGE: 'Se ha enviado un correo electrónico a',
    SUCCESS_MESSAGE: 'Se ha enviado un recibo que confirma su firma a',
    SUCCESS_COMPLETION: 'Cuando todos hayan firmado, recibirá un correo electrónico con un enlace al documento firmado',
    SUCCESS_COMPLETION_SINGLE_SIGNER: 'Se ha enviado a su correo electrónico un mensaje con un enlace al documento o documentos firmados',
    FORM_SUCCESS_COMPLETION: 'Cuando todos hayan firmado, recibirá un correo electrónico con un enlace al formulario firmado',
    FORM_SUCCESS_COMPLETION_SINGLE_SIGNER: 'Se ha enviado a su correo electrónico un mensaje con un enlace al formulario firmado',
    REFERENCE_ID: 'ID de referencia',
    LOGGED_OUT_MESSAGE: 'Se ha cerrado la sesión automáticamente y ya puede cerrar esta ventana',
    ALL_SIGNERS: 'Todos los firmantes',
    ALL_SIGNERS_SINGLE_SIGNER: 'Firmante',
    DOWNLOAD_MESSAGE: 'Tenga en cuenta que dispone de 90 días para descargar su copia del documento del acuerdo. Solo tiene que seguir el enlace del correo electrónico que le hemos enviado.',
    FORM_DOWNLOAD_MESSAGE: 'Tenga en cuenta que dispone de 90 días para descargar su copia del formulario. Solo tiene que seguir el enlace del correo electrónico que le hemos enviado.',
    FILES_ORDER_DOWNLOAD_MESSAGE: ', que contiene un recibo y un enlace a sus archivos.\nTenga en cuenta que dispone de 90 días para descargar su copia del contenido. Solo tiene que seguir el enlace del correo electrónico que se le ha enviado.',
    FILES_ORDER_REJECTED_HEADING: 'La orden ha sido cancelada',
    FILES_ORDER_REJECTED_MESSAGE: 'Se ha enviado una notificación al remitente.',
    REJECTED_BY_OWNER_TITLE: 'Orden cancelada por el propietario',
    REJECTED_BY_OWNER_MESSAGE: 'Esta orden ha sido cancelada por el propietario.',
    REJECTED_BY_SIGNER_TITLE: 'Orden cancelada: firma rechazada',
    REJECTED_BY_SIGNER_MESSAGE: 'Esta orden ha sido cancelada porque uno de los firmantes rechazó firmar.',
    NO_SIGNATURE_REQUIRED_HEADING: 'Correcto',
    NO_SIGNATURE_REQUIRED_REJECTED_HEADING: 'La orden ha sido cancelada',
    NO_SIGNATURE_REQUIRED_MESSAGE: 'Se ha enviado un correo electrónico a',
    NO_SIGNATURE_REQUIRED_REJECTED_MESSAGE: 'Se ha enviado una notificación al remitente.',
    NO_SIGNATURE_REQUIRED_MESSAGE_SUFFIX: ', que contiene un recibo y un enlace al documento de nombramiento. Dispone de 90 días para recuperar su copia del contrato siguiendo el enlace del correo electrónico.',
  },

  STATUS: {
    SIGNED: 'Firmado',
    RECEIVED: 'Recibido',
    PENDING: 'Pendiente',
    REJECTED: 'Rechazado',
    LOCKED: 'Bloqueado',
  },

  NOT_FOUND: {
    TITLE: 'Página no encontrada',
    DESCRIPTION: 'La página que busca no existe o el enlace de firma no es válido.',
  },

  NO_SUCH_APPROVER: {
    TITLE: 'Firmante interno no reconocido',
    DESCRIPTION: 'No se encontró ningún firmante interno que coincida con el MitID utilizado.',
  },

  NO_ACCESS_CPR: {
    TITLE: 'No se pudo completar la verificación del CPR',
    DESCRIPTION: 'El MitID utilizado no coincide con el número CPR que se debe verificar. Póngase en contacto con {{senderName}} e indique el n.º de referencia {{referenceId}}.',
  },

  ARCHIVED: {
    TITLE: 'La orden de firma no está accesible',
    DESCRIPTION: 'Lamentablemente, la orden de firma a la que intenta acceder ya no está disponible. La orden de firma y sus documentos se eliminan 90 días después de que la última persona haya firmado.',
  },

  ALREADY_SIGNED: {
    TITLE: 'Ya firmada',
    DESCRIPTION: 'Esta orden de firma ya ha sido firmada.',
  },

  CPR_ALREADY_SIGNED: {
    TITLE: 'Orden CPR ya firmada',
    DESCRIPTION: 'Esta orden de firma CPR ya se ha completado.',
  },

  VERIFY_ERROR: {
    TITLE: 'Error de verificación',
    DESCRIPTION: 'La identidad utilizada para firmar no coincide con la requerida para esta orden.',
  },

  ORDER_MISMATCH: {
    TITLE: 'La orden no coincide',
    DESCRIPTION: 'La orden de firma no coincide con la sesión actual. Cierre las demás pestañas e inténtelo de nuevo.',
  },

  PSEUDONYM_DISALLOWED: {
    TITLE: 'Usuarios con seudónimo no permitidos',
    DESCRIPTION: 'El cliente no permite firmar con una identidad seudónima.',
  },

  EXPIRED: {
    TITLE: 'La orden de firma ha caducado',
    DESCRIPTION: 'El remitente de esta orden de firma - {{documentReference}} - ha establecido una fecha límite para firmarla. Dicha fecha límite ha vencido.',
    SUB_DESCRIPTION: 'Póngase en contacto con el remitente {{senderName}} si tiene alguna pregunta o cree que se ha producido un error.',
    MORE_INFO: 'Haga clic aquí para obtener más información',
    INFO_TITLE: '¿Por qué hay una fecha límite?',
    INFO: 'Todas las órdenes de firma tienen una fecha límite. Esto permite al remitente asegurarse de que la orden se firme dentro del plazo que ha elegido.',
    SUB_TITLE: '¿Qué hago ahora?',
    SUB_INFO: 'Se ha notificado al remitente que una o más partes no han firmado dentro del plazo. Puede esperar a que el remitente se ponga en contacto con usted o comunicarse usted mismo con el remitente.',
  },

  STEP_LOCKED: {
    TITLE: 'Este paso está bloqueado actualmente',
    DESCRIPTION: 'Este paso de firma está bloqueado y no se puede completar en este momento. Póngase en contacto con el remitente para obtener más información.',
  },

  UNEXPECTED: {
    TITLE: 'Se ha producido un error inesperado',
    DESCRIPTION: 'Se ha producido un error inesperado al procesar su solicitud. Inténtelo de nuevo más tarde.',
  },

  STEP_NOT_AVAILABLE: {
    TITLE: 'Este paso aún no está disponible',
    DESCRIPTION: 'Este paso de firma aún no está disponible. Espere a que se complete el paso anterior antes de continuar.',
  },

  UNAUTHORIZED: {
    TITLE: 'Se ha producido un error',
    DESCRIPTION: 'No hemos podido verificar la sesión de firma. Inténtelo de nuevo con el enlace que recibió o póngase en contacto con el remitente.',
  },

  ERRORS: {
    UNAUTHORIZED: 'No está autorizado para acceder a este recurso',
    BAD_REQUEST: 'Solicitud no válida.',
    FORBIDDEN: 'El acceso a este recurso está prohibido',
    NOT_FOUND: 'No se pudo encontrar el recurso solicitado',
    SERVER_ERROR: 'Se ha producido un error en el servidor. Inténtelo de nuevo más tarde',
    UNKNOWN_ERROR: 'Se ha producido un error inesperado. Inténtelo de nuevo',
    SESSION_EXPIRED: 'Su sesión ha caducado. Se le está redirigiendo al inicio de sesión.',
  },

  RECEIPT_CPR: {
    SUCCESS_HEADING: 'Su identificación ha sido confirmada.',
    SUCCESS_MESSAGE: 'Hemos enviado un recibo de su verificación CPR a',
    REJECTED_HEADING: 'La firma ha sido rechazada',
    REJECTED_MESSAGE: 'Se ha enviado una notificación a',
  },

  CPR_CHECK: {
    INSTRUCTION: 'Introduzca su número CPR',
    CPR_NUMBER: 'Número CPR',
    CPR_NUMBER_PLACEHOLDER: 'Introduzca su número de identificación personal',
    HEALTH_INSURANCE_CARD: 'Suba una foto de su tarjeta sanitaria',
    PHOTO_ID: 'Suba una copia de un documento de identidad con foto, p. ej., pasaporte o carné de conducir',
    FILE_HINT: "Formatos admitidos: 'png', 'jpg', 'bmp'. Tamaño máximo del archivo: 10 MB.",
    PROTECTED_CPR_PHOTO_ID_REQUIRED: 'Como tiene protección de nombre y dirección, no podemos verificar sus datos. Complete los pasos siguientes.',
  },

  REJECT_MODAL: {
    TITLE: '¿Desea rechazar esta orden?',
    REASON_PLACEHOLDER: 'Escriba el motivo del rechazo',
    CONFIRM: 'Confirmar rechazo',
  },

  DOWNLOAD_STEP: {
    HEADING: 'Descargue sus documentos',
    DESCRIPTION: 'Ya puede descargar una copia de sus documentos firmados. Los documentos están disponibles durante 90 días a partir de la fecha de firma. Haga clic en el botón de descarga para guardarlos en su ordenador.',
    DOWNLOAD_BUTTON: 'Descargar copia',
    LOGOUT_BUTTON: 'Cerrar sesión',
    LOGGED_OUT_HEADING: 'Ha cerrado la sesión',
    LOGGED_OUT_DESCRIPTION: 'Gracias por utilizar Esignatur. Esperamos volver a verle.',
  },

  LOGOUT_MODAL: {
    TITLE: '¿Cerrar sesión?',
    DESCRIPTION: '¿Está seguro de que desea cerrar sesión? Se perderán los cambios no guardados.',
    CONFIRM: 'Cerrar sesión',
  },

  REJECTION_SUCCESS_MODAL: {
    TITLE: 'Orden rechazada correctamente',
    DESCRIPTION: 'Esta orden ha sido rechazada',
    CONTINUE: 'Continuar',
  },

  APPROVER_RECEIPT: {
    SUCCESS_HEADING: 'Sus firmas se han completado correctamente.',
    SUCCESS_MESSAGE: 'Se ha cerrado la sesión automáticamente y ya puede cerrar la ventana.',
  },

  SUPPORT: {
    CONTACT: 'Contáctenos por correo electrónico:',
  },
};
